import { useMemo } from 'react';
import type { AgentFinancialResponse } from '../../../api/events-client/events-client.type';
import type {
  AllocationOfCostsChartResponseByCategory,
  CostByInitiativeResponse,
} from '../../../api/financials-client/financials-client.type';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { Charts as ChartsType } from '../../../store/financials-store/financials-store.type';
import { Filters as AgentCostsFilters } from './agent-costs/filters';
import { Filters as AllocationOfCostFilters } from './allocation-of-costs/filters';
import { Filters as CostByInitiativeFilters } from './cost-by-initiative/filters';
import { Filters as CostVersusOutputFilters } from './cost-versus-output/filters';

interface FiltersProps {
  setShow: (show: boolean) => void;
  agentCostsData?: AgentFinancialResponse;
  allocationOfCostsData?: AllocationOfCostsChartResponseByCategory;
  costByInitiativeData?: CostByInitiativeResponse[];
  isPending: boolean;
}

function Filters({ setShow, agentCostsData, allocationOfCostsData, costByInitiativeData, isPending }: FiltersProps) {
  const selectedChart = useFinancialsStore((state) => state.chart);

  const filters = useMemo(() => {
    switch (selectedChart) {
      case ChartsType.AllocationOfCosts:
        return <AllocationOfCostFilters setShow={setShow} data={allocationOfCostsData} isPending={isPending} />;
      case ChartsType.CostVersusOutput:
        return <CostVersusOutputFilters setShow={setShow} />;
      case ChartsType.AgentCosts:
        return <AgentCostsFilters setShow={setShow} data={agentCostsData} isPending={isPending} />;
      default:
        return <CostByInitiativeFilters setShow={setShow} data={costByInitiativeData} isPending={isPending} />;
    }
  }, [selectedChart, setShow, agentCostsData, allocationOfCostsData, costByInitiativeData, isPending]);

  return filters;
}

export { Filters };
